import { render, staticRenderFns } from "./dataloggernewpannel.vue?vue&type=template&id=7791bcc0&scoped=true&"
import script from "./dataloggernewpannel.vue?vue&type=script&lang=js&"
export * from "./dataloggernewpannel.vue?vue&type=script&lang=js&"
import style0 from "./dataloggernewpannel.vue?vue&type=style&index=0&id=7791bcc0&lang=less&scoped=true&"
import style1 from "./dataloggernewpannel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7791bcc0",
  null
  
)

export default component.exports